import { useContext } from 'react';

import AuthSessionContext from 'contexts/AuthSessionProvider/AuthSessionContext';

const useAuthSession = () => {
  const ctx = useContext(AuthSessionContext);
  if (!ctx) {
    throw new Error('useAuthSession must be used within an AuthSessionProvider');
  }
  return ctx;
};

export default useAuthSession;
